import { Button} from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import './pagenot.css';
import  'bootstrap/dist/css/bootstrap.min.css';
const PageNot=()=>{
    return(
        <>
            <div className="container-fluid page-not ">
                <div className="row">
                    <div className="col-md-12">
                        <h1>OoPs </h1>
                        <h2>404 Page Not Found</h2>
                        <NavLink to='/'><Button><i class="fa-solid fa-circle-arrow-left fs-5"></i>&nbsp;Back to HomePage</Button></NavLink>
                    </div>
                </div>
            </div>
        </>
    )
}
export default PageNot;